/**
 * SOLID Review
 * S — Strong. One concern: the funnel's host intent — the table created.
 * O — Strong. What a create seats is the Domain's decision.
 * L — Strong. Implements its entry-step role exactly.
 * I — Strong. `take`.
 * D — Strong. The session's deps, injected.
 */
import type { IContextRequest } from '../ports/IContextRequest';
import type { ICommandNothing } from '../../domain/ports/schemas/TableMoves';
import type { ICommandTableHosted } from '../../domain/ports/schemas/SessionMoves';
import { SERVER_REFUSED } from '../ports/contracts';
import type { IConfigDepSession } from './IConfigDepSession';
import type { IServiceEntryStep } from './SessionEntryRoute';

const NOTHING: ICommandNothing = {};

/** The host intent (FE2's MainMenuPanel auto-host): create the table. A refusal keeps the server's own words for the panel. */
export class HostTableStep implements IServiceEntryStep {
  constructor(private readonly deps: IConfigDepSession) {}

  async take(ctx: IContextRequest): Promise<boolean> {
    const { decisions, step, rooms } = this.deps;
    const plan = await step.run(ctx, (input) => decisions.planHost(ctx, input, NOTHING));
    if (!plan.success) return false;
    const created = await rooms.createRoom(ctx, plan.value);
    const answer: ICommandTableHosted = created.success
      ? { request: plan.value, room: created.value, serverMessage: null }
      : { request: plan.value, room: null, serverMessage: created.error.code === SERVER_REFUSED ? created.error.message : null };
    await step.run(ctx, (input) => decisions.tableHosted(ctx, input, answer));
    return false;
  }
}
